// 快递单号导出

import LogisticsCompany from "@/enum/LogisticsCompany";
import mainServerClient from "@/services/http/mainServerClient";
import WaybillNoExportExportItem from "./enum/WaybillNoExportExportItem";
import { WaybillNoType } from "./enum/WaybillNoType";
import TaskStatusEnum from "@/enum/TaskStatus";
import { QueryOrderListParams } from "../../order";

/**时间范围类型 */
export enum WaybillNoExportTaskTimeType {
    /**打印时间 */
    PRINTED = "PRINTED",
    /**发货时间 */
    SHIPPED = "SHIPPED",
    /** 下单时间 */
    ORDERED = "ORDERED",
}

export interface WaybillNoExportTask {
    id: number;

    companyId: number;

    created: string;

    distributedTaskId: number;

    endTime: string;

    logisticsCompany: LogisticsCompany;

    needProductInfo: boolean;

    shopIds: number[];

    startTime: string;

    status: TaskStatusEnum;

    timeType: WaybillNoExportTaskTimeType;

    opUserName: string;

    clientIp: string;

    templateIds?: number[];

    ewaybillShippingAddressIds?: number[];

    exportItems: WaybillNoExportExportItem[];

    waybillNoTypes: WaybillNoType[];

    hasDownloadUrl: boolean;

    error?: string;
}

interface GetExportWaybillNoExportListParams {
    pageNo: number;

    pageSize: number;

    ids?: number;
}

// 获取当前用户的下载任务列表
export function getExportTask(
    params: GetExportWaybillNoExportListParams,
): Promise<{ items: WaybillNoExportTask[]; totalCount: number }> {
    return mainServerClient.get("/waybillNoExportTask", params);
}

export enum ExportStyle {
    DEFAULT_MULTI_ROW = "DEFAULT_MULTI_ROW",
    MERGED_PRODUCT_INFO_SINGLE_ROW = "MERGED_PRODUCT_INFO_SINGLE_ROW",
}

export interface ExportWaybillNoParams {
    end: string;
    /**快递公司名称，传入 null 表示查询全部。 */
    logisticsCompany: LogisticsCompany;
    /**是否需要查询商品信息：true 需要，false（默认值）不需要。 */
    needProductInfo: boolean;
    shopIds: number[];
    /**开始时间 */
    start: string;
    timeType: WaybillNoExportTaskTimeType;
    captchaKey: string;
    captchaText: string;
    ewaybillShippingAddressIds?: [];
    templateIds: number[];
    exportItems: WaybillNoExportExportItem[];
    waybillNoTypes: WaybillNoType[];
    exportStyle?: ExportStyle;
}

export enum ExportWaybillNoSortType {
    PRINTED = "PRINTED",
    SHIPPED = "SHIPPED",
    ORDER_ID = "ORDER_ID",
    ORDERED = "ORDERED",
}

export interface SelectedOrderTableExportWaybillNoParams {
    captchaKey?: string;
    captchaText?: string;
    exportItems: WaybillNoExportExportItem[];
    waybillNoTypes: WaybillNoType[];
    sortType: ExportWaybillNoSortType;
    orderIdsMap: {
        [shopId: number]: number[];
    };
}

export interface SearchAllOrderTableExportWaybillNoParams {
    captchaKey?: string;
    captchaText?: string;
    exportItems?: WaybillNoExportExportItem[];
    waybillNoTypes: WaybillNoType[];
    sortType: ExportWaybillNoSortType;
    listParamsMap: {
        [shopId: number]: QueryOrderListParams;
    };
}

export type OrderTableExportWaybillNoParams =
    | SelectedOrderTableExportWaybillNoParams
    | SearchAllOrderTableExportWaybillNoParams;

// 导出
export function exportWaybillNo(
    params: ExportWaybillNoParams | OrderTableExportWaybillNoParams,
): Promise<WaybillNoExportTask> {
    return mainServerClient.post("/waybillNoExportTask", params);
}

export function saveWaybillNoExportFields(exportItems: WaybillNoExportExportItem[]) {
    return mainServerClient.post("/stats/setting/save_waybill_no_export_fields", { exportItems });
}

export function getWaybillNoExportFields(): Promise<WaybillNoExportExportItem[]> {
    return mainServerClient.get("/stats/setting/waybill_no_export_fields");
}

export function getWaybillNoExportDownloadUrl(taskId: number): Promise<string> {
    return mainServerClient.get<string>("/waybillNoExportTask/download_url", { taskId });
}

export default {
    getExportTask,
    exportWaybillNo,
};
